import { MapPin } from 'lucide-react'
import SectionWrapper from '../ui/SectionWrapper'

const AREAS = [
  { name: 'London', isHQ: true },
  { name: 'St. Thomas', isHQ: false },
  { name: 'Strathroy', isHQ: false },
  { name: 'Woodstock', isHQ: false },
]

export default function ServiceAreas() {
  return (
    <SectionWrapper id="service-areas" bg="alt">
      <div className="max-w-6xl mx-auto px-4 text-center">
        {/* Section header */}
        <span className="fade-in-up inline-block text-accent-500 font-semibold text-sm uppercase tracking-widest mb-3">
          Where We Work
        </span>
        <h2 className="fade-in-up font-heading font-bold text-navy-900 text-4xl md:text-5xl mb-5">
          Service Areas
        </h2>
        <p className="fade-in-up text-ink-600 text-lg max-w-xl mx-auto mb-12">
          Proudly serving London, Ontario and surrounding communities with professional HVAC services.
        </p>

        {/* Area badges */}
        <div className="fade-in-up flex flex-wrap justify-center gap-4">
          {AREAS.map((area) =>
            area.isHQ ? (
              <div
                key={area.name}
                className="flex items-center gap-2.5 bg-navy-800 text-white font-semibold px-6 py-3.5 rounded-xl shadow-sm"
              >
                <MapPin size={16} className="text-accent-400" />
                <span>{area.name}</span>
                <span className="bg-accent-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wide">
                  HQ
                </span>
              </div>
            ) : (
              <div
                key={area.name}
                className="flex items-center gap-2 bg-surface-0 border border-surface-100 text-navy-800 font-semibold px-6 py-3.5 rounded-xl hover:border-accent-500/40 hover:shadow-sm transition-all duration-200"
              >
                <MapPin size={15} className="text-ink-400" />
                <span>{area.name}</span>
              </div>
            )
          )}
        </div>
      </div>
    </SectionWrapper>
  )
}
